import { createRef, useCallback, useEffect, useState } from 'react'
import { Form } from 'antd';

import UserTable from './components/UserTable';
import UserOperationBar from './components/UserOperationBar';
import ModalCreateUser from './components/ModalCreateUser';

import { queryTable } from './service';
import { DEFAULT_QUERY } from './dict';
import './style.scss'

const UserMng = props => {
    const [data, setData] = useState({})
    const [query, setQuery] = useState(DEFAULT_QUERY)
    const [form] = Form.useForm()
    const _refModalCreate = createRef()

    const fetchTable = useCallback(() => {
        queryTable(query).then(res => setData(res.data))
    }, [query])

    useEffect(() => {
        fetchTable()
    }, [query, fetchTable])

    const onCreate = () => {
        _refModalCreate.current.open({ type: 'create' })
    }

    const onEdit = rcd => {
        _refModalCreate.current.open({ ...rcd, type: 'edit' })
    }

    return <div className="user-mng-container">
        <UserOperationBar
            onCreate={onCreate}
            query={query}
            setQuery={setQuery}
            form={form}
        />
        <UserTable
            setQuery={setQuery}
            onEdit={onEdit}
            onReload={fetchTable}
            query={query}
            data={data}
        />
        <ModalCreateUser
            ref={_refModalCreate}
            onReload={fetchTable}
        />
    </div>
}

export default UserMng
